import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { getBearerToken } from '../../../utils/Apis'
import { Constants } from '../../../utils/Constants'

const SideMenu = () => {

    const search = useLocation().pathname
    const navigate = useNavigate()
    const [openedMenu, setopenedMenu] = React.useState("")

    const fetch_acces_token = async () => {


        getBearerToken("updateAccessTokenUsingRefreshToken").then((result) => {
            if (result.error_code == 0) {
                alert("Updated")
            } else {
                // notify(JSON.stringify(result.messages))
            }
        })
    }

    React.useEffect(() => {
        openMenu()
    }, [])
    

    const openMenu = (val=null) => {
        if(val != null && openMenu==""){
            setopenedMenu(val)
            localStorage.setItem(Constants.OPENEDMENU , val)
        }
        if(val == null && openMenu!=""){
            setopenedMenu(val)
            localStorage.setItem(Constants.OPENEDMENU , openedMenu)
        }
        if(val != null && openMenu!=""){
            setopenedMenu(val)
            localStorage.setItem(Constants.OPENEDMENU , val)
        }
        if(val == null && openMenu==""){
            let z = localStorage.getItem(Constants.OPENEDMENU)
            if(z==undefined || z=="" || z==null){
                setopenedMenu("Admin")
            }else{
                setopenedMenu(z)
            }
        }
    }
    return (
        <nav className="side-nav">
            <ul>

                <li>
                    <div style={{cursor:"pointer"}} onClick={() => openMenu("Admin")} className={search == "/create_admin" || search == "/admin_list" || search == "/" ? "side-menu  side-menu--active" : "side-menu"}>
                        <div class="side-menu__icon"> <i data-lucide="home"></i> </div>
                        <div class="side-menu__title">
                            User Management
                            <div class="side-menu__sub-icon transform rotate-180"> <i data-lucide="chevron-down"></i> </div>
                        </div>
                    </div>
                    {
                        openedMenu == "Admin" 
                        ?
                        <ul class="side-menu__sub-open">
                        <li>
                            <a href="/sub_admin_list" className={search == "/sub_admin_list" || search == "/" ? "side-menu  side-menu--active" : "side-menu"}>
                                <div className="side-menu__icon"> <i data-lucide="box"></i> </div>
                                <div className="side-menu__title">
                                    User List
                                </div>
                            </a>
                        </li>
                        <li>
                            <a href="/create_sub_admin" className={search == "/create_sub_admin" ? "side-menu  side-menu--active" : "side-menu"}>
                                <div className="side-menu__icon"> <i data-lucide="box"></i> </div>
                                <div className="side-menu__title">
                                    Add User
                                </div>
                            </a>
                        </li>
                    </ul>
                        :
                        null
                    }
                    

                </li>
                <li>
                    <div style={{cursor:"pointer"}} onClick={() => openMenu("Rooms")} className={search == "/create_room" || search == "/room_list"  ? "side-menu  side-menu--active" : "side-menu"}>
                        <div class="side-menu__icon"> <i data-lucide="home"></i> </div>
                        <div class="side-menu__title">
                            Room Management
                            <div class="side-menu__sub-icon transform rotate-180"> <i data-lucide="chevron-down"></i> </div>
                        </div>
                    </div>
                    {
                        openedMenu == "Rooms" 
                        ?
                        <ul class="side-menu__sub-open">
                        <li>
                            <a href="/room_list" style={{cursor:"pointer"}} className={search == "/room_list"  ? "side-menu  side-menu--active" : "side-menu"}>
                                <div className="side-menu__icon"> <i data-lucide="box"></i> </div>
                                <div className="side-menu__title">
                                    Room List
                                </div>
                            </a>
                        </li>
                        <li>
                            <a href="/create_room" className={search == "/create_room" ? "side-menu  side-menu--active" : "side-menu"}>
                                <div className="side-menu__icon"> <i data-lucide="box"></i> </div>
                                <div className="side-menu__title">
                                    Add Room
                                </div>
                            </a>
                        </li>
                    </ul>
                        :
                        null
                    }
                    

                </li>
                <li>
                    <div className="side-menu" style={{cursor:"pointer"}} onClick={() => {
                        navigate("/profile")
                    }}>
                        <div className="side-menu__icon"> <i data-lucide="box"></i> </div>
                        <div className="side-menu__title">
                            Profile
                        </div>
                    </div>
                </li>
                <li>
                    <div className="side-menu" style={{cursor:"pointer"}} onClick={() => {
                        navigate("/cloud_recordings")
                    }}>
                        <div className="side-menu__icon"> <i data-lucide="box"></i> </div>
                        <div className="side-menu__title">
                            Cloud Recordings
                        </div>
                    </div>
                </li>
                <li>
                    <div className="side-menu" style={{cursor:"pointer"}} onClick={() => {
                        navigate("/messages")
                    }}>
                        <div className="side-menu__icon"> <i data-lucide="box"></i> </div>
                        <div className="side-menu__title">
                            Messages
                        </div>
                    </div>
                </li>
                <li>
                    <div className="side-menu" style={{cursor:"pointer"}} onClick={() => {
                        navigate("/online-users")
                    }}>
                        <div className="side-menu__icon"> <i data-lucide="box"></i> </div>
                        <div className="side-menu__title">
                            Online Users
                        </div>
                    </div>
                </li>
                <li>
                    <div className="side-menu" onClick={() => {
                        localStorage.clear()
                        navigate("/login")
                    }}>
                        <div className="side-menu__icon"> <i data-lucide="box"></i> </div>
                        <div className="side-menu__title">
                            Logout
                        </div>
                    </div>
                </li>
                

            </ul>
        </nav>
    )
}

export default SideMenu